import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space, Select } from "@masterteam/mt-design-react";

import Theme from "./Theme";
import { useIsAr } from "../../../Hooks";

import "./style.scss";

const ThemesPerformance = ({ data, kpiStatuses, projectStatuses }) => {
  const [isAr] = useIsAr();
  const [selectedThemes, setSelectedThemes] = useState([]);

  const getThemes = () =>
    selectedThemes?.length
      ? data?.Themes?.filter((item) =>
          selectedThemes?.some(
            (selectedTheme) => selectedTheme?.ID === item?.ID
          )
        )
      : data?.Themes;

  return (
    <Space
      direction="vertical"
      className="themes-performance"
      size="large"
      gap={30}
    >
      <Row
        size="large"
        align="center"
        justify="between"
        className="themes-performance__header"
      >
        <div className="themes-performance__title">
          <FormattedMessage id="dashboards.themes-performance" />
        </div>

        <Space align="center" className="themes-performance__field-wrapper">
          <div className="themes-performance__title">
            <FormattedMessage id="common.themes" />
          </div>
          <Select
            options={data?.ThemeSelectionList}
            placeholder={<FormattedMessage id="common.themes" />}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.ID}
            onChange={(item) => {
              setSelectedThemes(item);
            }}
            value={selectedThemes}
            className="themes-performance__select"
            isMulti
          />
        </Space>
      </Row>

      <Space direction="vertical" gap={40}>
        {getThemes()?.map((item) => (
          <Theme
            item={item}
            kpiStatuses={kpiStatuses}
            projectStatuses={projectStatuses}
          />
        ))}
      </Space>
    </Space>
  );
};

export default ThemesPerformance;
